<template>
    <div>
        <base-dropdown ref="dropdown" class="nav-link pr-0" :position="'right'" :customDrop="true">
          <div class="media align-items-center custom-media-nav-size" slot="title">
            <div class="media-body ml-2 d-none d-md-block d-lg-block pr-1">
              <span class="mb-0 text-sm font-weight-bold">{{$store.state.userInfo.agentName}}<br>
              </span>
              <p class="mb-0 small">角色</p>
            </div>
            <span class="b-avatar badge-primary rounded-circle">
              <span class="b-avatar-text">
                <img :src="$store.state.userInfo.imageUrl ? $store.state.userInfo.imageUrl : 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg'" alt="" style="width: 100%;height: 100%">
              </span>
            </span>
            <i class="fas fa-caret-down pl-2"></i>
          </div>
          <template>
            <div class="dropdown-header noti-title dropdown-menu-left">
              <a class="dropdown-item p-0"
                :class="visibleShopDetails ? null : 'collapsed'"
                :aria-expanded="visibleShopDetails ? 'true' : 'false'"
                aria-controls="collapse-shop-detail"
                @mouseover="visibleShopDetails = true"
                @mouseleave="visibleShopDetails = false"
              >
                <div class="row">
                  <div class="col-12 col-lg-12 col-xl-12 col-md-12">
                    <template>
                    <h4>{{ $store.state.userInfo.agentCode }}</h4>
                    <h6>{{ $store.state.userInfo.email }}</h6>
                    </template>
<!--                    <template v-else>-->
<!--                        <h4 class="pt-3">{{this.$USER_LOGIN.get().details.email}}</h4>-->
<!--                    </template>-->
                  </div>
                  <!-- <div class="col-12 col-lg-4 col-xl-4 col-md-4">
                    <i class="fas fa-angle-right fa-lg pt-4 pl-5" v-if="!visibleShopDetails"></i>
                    <i class="fas fa-angle-down fa-lg pt-4 pl-5" v-else></i>
                  </div> -->
                </div>
              </a>
            </div>
            <!-- <b-collapse id="collapse-shop-detail" v-model="visibleShopDetails" class="mt-2"> -->
              <div class="dropdown-divider"></div>
                <BaseShopDetails></BaseShopDetails>
            <!-- </b-collapse> -->
            <div class="dropdown-divider"></div>
            <template>
                <router-link to="/" class="dropdown-item">
                    <Icon icon="mdi-home" />
                    <span>หน้าแรก</span>
                </router-link>
                <router-link to="/topupcredit" class="dropdown-item">
                    <Icon icon="mdi-wallet-plus" />
                    <span>เติมเครดิต</span>
                </router-link>
                <router-link to="/" class="dropdown-item" :disabled="true" >
                    <Icon icon="mdi-school" />
                    <span>การสร้างยอดขาย</span>
                </router-link>
                <router-link to="/reporttransport" class="dropdown-item">
                    <Icon icon="mdi-finance" />
                    <span>รายงานพัสดุ</span>
                </router-link>
                <div class="dropdown-divider"></div>
            </template>
            <div to="/logout" class="dropdown-item" @click="logout">
                <!-- <Icon icon="mdi-exit-to-app"/> -->
                <i class="fas fa-sign-out-alt text-color-wallet"></i>
                <span class="text-color-wallet">ออกจากระบบ</span>
            </div>
          </template>
        </base-dropdown>
    </div>
</template>

<script>
import BaseShopDetails from "@/components/BaseShopDetails"
export default {
    name:"DropDownShop",
    components:{
      BaseShopDetails
    },
    data() {
      return {
          visibleShopDetails: false,
          userInfo: null
      }
    },
    computed:{

    },
    mounted() {
        this.$store.dispatch('getUserInfo')
        // this.$store.dispatch('getUserInfo')
          this.userInfo = this.$store.state.userInfo
        console.log(this.userInfo)
    },
    methods: {
        logout(){
            this.$router.push('/login')
        }
    }
}
</script>
